import type { Toast as ToastType } from 'react-hot-toast';
import { toast as reactHotToast } from 'react-hot-toast';

import type { ToastVariant } from './Toast';
import { Toast } from './Toast';

export interface CreateToastOptions {
    id?: string;
    duration?: number;
}

const DEFAULT_DURATION_MS = 4000;

const createToast = (text: string, type: ToastVariant, options?: CreateToastOptions) =>
    reactHotToast.custom(
        (t: ToastType) => (
            <Toast
                type={type}
                text={text}
                isVisible={t.visible}
                onClose={() => reactHotToast.dismiss(t.id)}
                dataTestid='hot-toast'
            />
        ),
        {
            position: 'top-right',
            // Explicit, otherwise updating a loading toast by id keeps its infinite duration
            duration: type === 'loading' ? Infinity : DEFAULT_DURATION_MS,
            ...options,
        }
    );

export const toast = {
    default: (text: string, options?: CreateToastOptions) => createToast(text, 'default', options),
    success: (text: string, options?: CreateToastOptions) => createToast(text, 'success', options),
    info: (text: string, options?: CreateToastOptions) => createToast(text, 'info', options),
    warning: (text: string, options?: CreateToastOptions) => createToast(text, 'warning', options),
    error: (text: string, options?: CreateToastOptions) => createToast(text, 'error', options),
    loading: (text: string, options?: CreateToastOptions) => createToast(text, 'loading', options),
};
